import { Ability } from '@casl/ability'

var ability = new Ability([])

export default ability